import React from "react";
import "./TinyHeader.scss";
const TinyHeader = () => {
  return <div className="tiny_header"></div>;
};

export default TinyHeader;
